module.exports = __webpack_public_path__ + "img/五化果园.d8c35503.png";